var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGenesisLogo = function SvgGenesisLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    stroke: "#fff",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.475 49.744c2.11.271 4.389 2.634 6.86 5.958.377.633.754 1.287 1.132 1.961 5.288 9.553 9.355 23.137 16.855 29.174 25.113 20.226 48.382-42.639 76.034 4.522 12.776-18.842 12.861-43.541.213-62.471C93.922 9.958 71.063.571 48.753 5.144 26.443 9.716 9.126 27.339 4.954 49.715c.157-.012.313-.012.47 0l.05.029Z",
    fill: "url(#genesisLogo_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01 60.037C4.01 90.945 29.08 116 60.005 116 90.93 116 116 90.945 116 60.037c0-8.247-7.483-31.83-26.052-31.83-20.854 0-28.88 53.43-52.256 53.43-14.095 0-24.694-32.221-32.72-31.91a67.197 67.197 0 0 0-.962 10.31Z",
    fill: "url(#genesisLogo_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.478 57.669a82.633 82.633 0 0 0-1.131-1.962c-2.681-3.584-5.142-6.082-7.393-5.992 2.568-.101 5.396 3.29 8.524 7.954Z",
    fill: "url(#genesisLogo_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.474 49.744c2.427.333 5.09 3.578 8.004 7.914a82.289 82.289 0 0 0-1.132-1.962c-2.483-3.318-4.762-5.675-6.872-5.952Z",
    fill: "url(#genesisLogo_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.424 49.738Z",
    fill: "url(#genesisLogo_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.424 49.738Z",
    fill: "url(#genesisLogo_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m106.26 91.54.108-.152-.108.153Z",
    fill: "url(#genesisLogo_svg__g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m106.26 91.54.108-.152-.108.153Z",
    fill: "url(#genesisLogo_svg__h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.334 86.837c-7.5-6.037-11.567-19.615-16.855-29.174-2.913-4.347-5.572-7.586-8.004-7.914h-.05a2.943 2.943 0 0 0-.47 0 55.94 55.94 0 0 0 11.963 46.042A56.008 56.008 0 0 0 60.005 116h2.161l1.13-.057.566-.033 1.132-.091.509-.045c.52-.051 1.046-.107 1.56-.175h.046a79.325 79.325 0 0 0 1.595-.226l.48-.08 1.132-.192.566-.102 1.086-.226.492-.107c.49-.109.976-.226 1.459-.351h.08c.508-.13 1.017-.271 1.526-.418l.459-.135 1.063-.328.52-.17 1.035-.35.47-.164c.46-.166.918-.338 1.374-.515l.085-.034c.486-.192.969-.39 1.448-.593l.418-.181 1.018-.458.481-.226.979-.475.435-.215c.426-.215.849-.435 1.267-.661l.102-.057c.456-.248.907-.503 1.352-.763l.379-.226.961-.565.442-.277.916-.565.401-.266 1.16-.797.107-.074c.423-.297.84-.603 1.25-.915l.34-.26.888-.696.401-.322.837-.695.362-.305c.351-.302.698-.607 1.041-.916l.113-.102c.377-.347.754-.699 1.131-1.057l.3-.288c.272-.264.54-.53.803-.797l.357-.362.746-.786.323-.35c.305-.336.607-.673.905-1.012l.118-.136c.34-.377.672-.77.996-1.181l.26-.323c.238-.293.473-.59.707-.887l.311-.407c.219-.286.434-.575.645-.865l.288-.396c.257-.358.509-.72.758-1.085l.108-.153C78.71 44.21 55.446 107.064 30.333 86.838Z",
    fill: "url(#genesisLogo_svg__i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.334 86.837c-7.5-6.037-11.567-19.615-16.855-29.174-2.913-4.347-5.572-7.586-8.004-7.914h-.05a2.943 2.943 0 0 0-.47 0 55.94 55.94 0 0 0 11.963 46.042A56.008 56.008 0 0 0 60.005 116h2.161l1.13-.057.566-.033 1.132-.091.509-.045c.52-.051 1.046-.107 1.56-.175h.046a79.325 79.325 0 0 0 1.595-.226l.48-.08 1.132-.192.566-.102 1.086-.226.492-.107c.49-.109.976-.226 1.459-.351h.08c.508-.13 1.017-.271 1.526-.418l.459-.135 1.063-.328.52-.17 1.035-.35.47-.164c.46-.166.918-.338 1.374-.515l.085-.034c.486-.192.969-.39 1.448-.593l.418-.181 1.018-.458.481-.226.979-.475.435-.215c.426-.215.849-.435 1.267-.661l.102-.057c.456-.248.907-.503 1.352-.763l.379-.226.961-.565.442-.277.916-.565.401-.266 1.16-.797.107-.074c.423-.297.84-.603 1.25-.915l.34-.26.888-.696.401-.322.837-.695.362-.305c.351-.302.698-.607 1.041-.916l.113-.102c.377-.347.754-.699 1.131-1.057l.3-.288c.272-.264.54-.53.803-.797l.357-.362.746-.786.323-.35c.305-.336.607-.673.905-1.012l.118-.136c.34-.377.672-.77.996-1.181l.26-.323c.238-.293.473-.59.707-.887l.311-.407c.219-.286.434-.575.645-.865l.288-.396c.257-.358.509-.72.758-1.085l.108-.153C78.71 44.21 55.446 107.064 30.333 86.838Z",
    fill: "url(#genesisLogo_svg__j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.334 86.837c-7.5-6.037-11.567-19.615-16.855-29.174-2.427-4.222-5.572-7.586-8.004-7.914h-.05a2.943 2.943 0 0 0-.47 0 55.94 55.94 0 0 0 11.963 46.042A56.008 56.008 0 0 0 60.005 116h2.161l1.13-.057.566-.033 1.132-.091.509-.045c.52-.051 1.046-.107 1.56-.175h.046a79.325 79.325 0 0 0 1.595-.226l.48-.08 1.132-.192.566-.102 1.086-.226.492-.107c.49-.109.976-.226 1.459-.351h.08c.508-.13 1.017-.271 1.526-.418l.459-.135 1.063-.328.52-.17 1.035-.35.47-.164c.46-.166.918-.338 1.374-.515l.085-.034c.486-.192.969-.39 1.448-.593l.418-.181 1.018-.458.481-.226.979-.475.435-.215c.426-.215.849-.435 1.267-.661l.102-.057c.456-.248.907-.503 1.352-.763l.379-.226.961-.565.442-.277.916-.565.401-.266 1.16-.797.107-.074c.423-.297.84-.603 1.25-.915l.34-.26.888-.696.401-.322.837-.695.362-.305c.351-.302.698-.607 1.041-.916l.113-.102c.377-.347.754-.699 1.131-1.057l.3-.288c.272-.264.54-.53.803-.797l.357-.362.746-.786.323-.35c.305-.336.607-.673.905-1.012l.118-.136c.34-.377.672-.77.996-1.181l.26-.323c.238-.293.473-.59.707-.887l.311-.407c.219-.286.434-.575.645-.865l.288-.396c.257-.358.509-.72.758-1.085l.108-.153C78.71 44.21 55.446 107.064 30.333 86.838Z",
    fill: "url(#genesisLogo_svg__k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.12 61.253c0-4.133-2.38-6.67-6.36-6.67-3.296 0-6.331 2.668-6.331 6.783a6.608 6.608 0 0 0 6.76 6.868c2.572 0 4.393-1.051 5.427-2.38l-2.069-2.063a3.985 3.985 0 0 1-3.21 1.458c-1.793 0-3.392-1.232-3.477-2.928h9.22c.017-.153.04-.588.04-1.068Zm-9.18-1.312a2.787 2.787 0 0 1 2.876-2.538c1.99 0 2.827 1.328 2.878 2.538h-5.755ZM64.422 67.844h-3.477V54.95h3.392v1.21a4.466 4.466 0 0 1 3.55-1.527c2.967 0 4.799 2.261 4.799 5.088v8.14h-3.477v-7.524c0-1.368-.79-2.566-2.38-2.566-1.486 0-2.407 1.175-2.407 2.668v7.405ZM95.02 60.066c-.786-.198-1.17-.289-1.797-.453-.752-.203-1.199-.508-1.199-1.08 0-.689.667-1.18 1.617-1.18a4.12 4.12 0 0 1 3.018 1.446l2.171-2.153a6.676 6.676 0 0 0-4.986-2.047c-2.996 0-5.2 1.877-5.2 4.212 0 1.922 1.13 3.075 3.685 3.793.877.248 1.278.328 1.9.497.814.22 1.362.622 1.362 1.227 0 .605-.526 1.08-1.752 1.08-1.572 0-2.685-1.03-3.296-1.566l-2.114 2.086a7.264 7.264 0 0 0 5.37 2.329c3.392 0 5.167-2.137 5.167-4.229.011-1.905-1.3-3.29-3.946-3.962ZM100.769 67.844V54.95h3.476V67.82l-3.476.023ZM87.067 61.253c0-4.133-2.38-6.67-6.36-6.67-3.295 0-6.33 2.668-6.33 6.783a6.608 6.608 0 0 0 6.782 6.88c2.572 0 4.393-1.052 5.427-2.38l-2.069-2.064a3.985 3.985 0 0 1-3.21 1.458c-1.793 0-3.392-1.232-3.477-2.928h9.22c-.006-.164.017-.599.017-1.08Zm-9.18-1.306a2.787 2.787 0 0 1 2.877-2.538c1.99 0 2.826 1.328 2.877 2.538h-5.755ZM106.218 58.794c0 1.922 1.131 3.075 3.686 3.793.876.248 1.277.328 1.899.497.814.22 1.363.622 1.363 1.227 0 .605-.526 1.08-1.753 1.08-1.571 0-2.685-1.03-3.295-1.566l-2.115 2.086a7.266 7.266 0 0 0 5.371 2.329 5.448 5.448 0 0 0 4.171-1.617c.181-1.532.294-3.08.345-4.652-.633-.854-1.735-1.504-3.307-1.9-.785-.198-1.17-.288-1.797-.452-.752-.203-1.199-.509-1.199-1.08 0-.69.667-1.181 1.617-1.181a4.128 4.128 0 0 1 3.036 1.441l1.599-1.588c0-.384-.045-.774-.073-1.13a6.824 6.824 0 0 0-4.353-1.499c-2.985 0-5.195 1.877-5.195 4.212ZM41.211 54.95v1.266a5.37 5.37 0 0 0-3.957-1.492c-3.33 0-6.308 2.894-6.308 6.755a6.483 6.483 0 0 0 6.336 6.755 5.172 5.172 0 0 0 3.828-1.611v1.13c0 2.205-1.651 3.437-3.703 3.437a5.398 5.398 0 0 1-3.697-1.616l-2.261 2.26a8.208 8.208 0 0 0 6.122 2.573c4.805 0 7.01-3.76 7.01-7.072V54.95h-3.37Zm-3.448 10.022a3.5 3.5 0 1 1 3.5-3.499 3.5 3.5 0 0 1-3.494 3.522l-.006-.023ZM102.499 48.11a2.385 2.385 0 1 1-.012 4.77 2.385 2.385 0 0 1 .012-4.77Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.283
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(85.1914 0 0 85.1423 4.966 52.056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(101.826 0 0 101.767 8.601 69.84)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1535.54 0 0 1534.65 177.021 975.297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1205.46 0 0 1204.77 111.861 721.477)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(70.7759 0 0 1.41336 11.263 50.526)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(84.6537 0 0 1.69049 15.038 50.82)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(19.3883 0 0 27.551 108.563 109.188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(26.5268 0 0 37.695 113.992 82.365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F26830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15421.2 0 0 15412.3 898.249 5673.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F69322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(18444.6 0 0 18434 1433.45 7758.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAF3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FAAA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F89D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F68639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F37237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#F26535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EE4E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EA2F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9262A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "genesisLogo_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(25254.2 0 0 25239.7 17573.5 6366.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F47738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F26830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15B28"
  })))));
};

export default SvgGenesisLogo;